export default "__VITE_ASSET__5eb91a79__"